<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width d-flex align-items-center">
        <div class="col-sm-12 col-md-5">
          <span class="toolbar-title">{{ labelTitle }}</span>
        </div>
        <div
          class="col-sm-12 col-md-7 d-flex justify-content-end"
          style="gap: 0.5rem"
        >
          <button
            mat-flat-button
            color="primary"
            (click)="
              openLink(
                'https://docs.google.com/forms/d/e/1FAIpQLScG1uYt_8pLHCFYv_5eT_JBHMW55eX4zEFQb3YZUrEzDwis9A/viewform'
              )
            "
            matTooltip="New ASCC user request form"
            *ngIf="requestUserPrivilege"
          >
            <mat-icon>person_add</mat-icon>
          </button>
          <button
            mat-flat-button
            color="accent"
            (click)="enableMove = !enableMove"
            matTooltip="Modify Order"
            *ngIf="createCategoryPrivilege"
          >
            <mat-icon>swipe_vertical</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      #sidenav
      class="d-print-none"
      mode="side"
      opened="true"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item>
          <!-- <span *ngIf="isExpanded || isShowing">Filter</span> -->
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list class="full-height">
        <mat-list-item class="full-height d-flex flex-column">
          <apl-category-v2-list
            class="full-height full-width"
            [aplCategories]="APLCategories.aplCategoriesFiltered"
          >
          </apl-category-v2-list>
        </mat-list-item>
      </mat-nav-list>
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          (click)="create()"
          class="parent"
          *ngIf="createCategoryPrivilege"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New Category</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div class="sidenav-content">
          <apl-category-v2-categories
            #APLCategories
            [filter]="filter"
            [enableMove]="enableMove"
          >
          </apl-category-v2-categories>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "loading" [message]="loadingMessage">
  <!-- </overlay-loading> -->
</div>
